"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = require("./styles");
var ContextMenu = function (_a) {
    var items = _a.items, children = _a.children;
    var _b = (0, react_1.useState)(false), open = _b[0], setOpen = _b[1];
    var containerRef = (0, react_1.useRef)(null);
    var handleToggleOpen = function () {
        setOpen(function (old) { return !old; });
    };
    (0, useClickOutside_1.default)(containerRef, function () {
        setOpen(false);
    });
    var handleClickItem = function (onClick) {
        setOpen(false);
        onClick();
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: containerRef }, { children: [(0, jsx_runtime_1.jsx)(styles_1.ContextMenuOpener, __assign({ "data-testid": "context-menu-opener", onClick: handleToggleOpen }, { children: children })), open && ((0, jsx_runtime_1.jsx)(styles_1.ItemsContainer, { children: items.map(function (item) { return ((0, jsx_runtime_1.jsxs)(styles_1.Item, __assign({ onClick: function () { return handleClickItem(item.onClick); }, className: (0, classnames_1.default)({ destructive: item.type === 'destructive' }) }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { name: item.icon }), (0, jsx_runtime_1.jsx)(styles_1.ItemLabel, __assign({ size: "lg" }, { children: item.label }))] }), item.label)); }) }))] })));
};
exports.default = ContextMenu;
